import { Faq } from "@appComponents/Faq";
import { Tabs } from "antd";
import React from "react";
import {
  overviewFaq,
  shareOwnershipFaq,
  shareOwnershipText,
  tradingFaq,
} from "../utils/const";

const tabs = [
  {
    label: "Overview",
    key: "overview",
    children: <Faq faq={overviewFaq} />,
  },
  {
    label: "FAQ",
    key: "faq",
    children: <Faq faq={tradingFaq} />,
  },
  {
    label: "Share ownership",
    key: "shareOwnership",
    children: (
      <>
        <p>{shareOwnershipText}</p>
        <Faq faq={shareOwnershipFaq} />
      </>
    ),
  },
];

export const FaqSection = () => {
  return (
    <Tabs defaultActiveKey={tabs[0].key} items={tabs} destroyInactiveTabPane />
  );
};
